import { ModalNames, useModals } from 'components/modals';
import {
  ENROLLMENT_EVENTS,
  useDutchiePayAnalytics,
} from 'src/payments/hooks/use-dutchie-pay-analytics/use-dutchie-pay-analytics';
import { useOpenDutchiePay } from 'src/payments/hooks/use-open-dutchie-pay/use-open-dutchie-pay';
import useUI from 'src/hooks/use-ui';
import { PaySignUpButtonProps } from './pay-sign-up-button';

type UsePaySignUpButtonProps = {
  goToCheckout?: () => void;
  refHref?: string;
  cname?: string;
  enrollmentSource?: string;
  location: PaySignUpButtonProps['location'];
};

type HandleClickProps = {
  experimentFlagName: string;
  experimentVariant: string;
};

type UsePaySignUpButtonResponse = {
  handleClick: (props?: HandleClickProps) => void;
};

export const usePaySignUpButton = ({
  goToCheckout,
  cname,
  refHref,
  enrollmentSource,
  location,
}: UsePaySignUpButtonProps): UsePaySignUpButtonResponse => {
  const { isMobileEcommApp } = useUI();
  const { dutchiePayEventTracker } = useDutchiePayAnalytics();
  const { openDutchiePay } = useOpenDutchiePay({ cname: cname ?? '', refHref, enrollmentSource });
  const { openModal } = useModals();

  const handleClick = (analyticsData?: HandleClickProps): void => {
    if (isMobileEcommApp) {
      void openModal(ModalNames.dutchiePayVisitOnDesktop);
    } else if (goToCheckout) {
      goToCheckout();
    } else {
      openDutchiePay();
      dutchiePayEventTracker(ENROLLMENT_EVENTS.ENROLLMENT_BUTTON_CLICKED, {
        buttonLocation: location,
        ...(analyticsData && { ...analyticsData }),
      });
    }
  };

  return {
    handleClick,
  };
};
